import { createEventTracker } from '../util';
import { SegmentAnalytics, SegmentSearchAnalytics } from './segments-search';

export const trackSegmentsSearch = createEventTracker<SegmentSearchAnalytics>('Segments Search');
export const trackSegmentSaved = createEventTracker<SegmentAnalytics>('Segment Saved');
